import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './Login.css';

export default function ChooseStaffAccess() {
  const { currentUser, selectStaffMode, logout } = useAuth();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false), [error, setError] = useState(null);
  const choose = async mode => {
    try {
      setPending(true); setError(null);
      const user = await selectStaffMode(mode);
      navigate(user.userType === 'support' ? '/support' : '/admin/dashboard', { replace: true });
    } catch (_) { setError('Access could not be selected. Try again or sign in again.'); }
    finally { setPending(false); }
  };
  return <div className="login-container"><h1 className="login-title">Choose your access</h1>
    <p>Which area would you like to use?</p>
    {error && <p role="alert">{error}</p>}
    {(currentUser?.availableModes || []).map(mode => <button key={mode} type="button" className="submit-button" disabled={pending}
      onClick={() => choose(mode)}>{mode === 'admin' ? 'Administration' : 'Support'}</button>)}
    <button type="button" disabled={pending} onClick={logout}>Sign out</button>
  </div>;
}
